module.exports = __webpack_public_path__ + "img/emoji-nerd-240x240.c1e01668.png";